// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"668cc2ce","264":"8bc81d29","432":"98567a59","453":"e42d539d","480":"be2de745","638":"867628d4","738":"992f8850"}[chunkId] + ".chunk.js";
};